import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem('adminToken', response.data.access_token);
      toast.success('Login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error('Invalid credentials. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="font-heading text-4xl font-light text-navy mb-2">JMD WILDLIFE</h1>
          <p className="font-body text-muted-foreground">Admin Dashboard</p>
        </div>

        {/* Login Form */}
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-navy/10 p-4 rounded-full">
              <Lock size={32} className="text-emerald-600" />
            </div>
          </div>

          <h2 className="font-heading text-2xl text-navy text-center mb-6">Admin Login</h2>

          <form onSubmit={handleLogin} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block font-body text-sm font-medium text-navy mb-2">
                Username
              </label>
              <div className="relative">
                <User size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
                <input
                  type="text"
                  data-testid="admin-username-input"
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  required
                  className="w-full pl-10 pr-4 py-3 border border-border rounded-lg focus:border-navy focus:ring-1 focus:ring-jungle font-body"
                  placeholder="Enter username"
                />
              </div>
            </div>

            <div>
              <label className="block font-body text-sm font-medium text-navy mb-2">
                Password
              </label>
              <div className="relative">
                <Lock size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
                <input
                  type="password"
                  data-testid="admin-password-input"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  required
                  className="w-full pl-10 pr-4 py-3 border border-border rounded-lg focus:border-navy focus:ring-1 focus:ring-jungle font-body"
                  placeholder="Enter password"
                />
              </div>
            </div>

            <button
              type="submit"
              data-testid="admin-login-submit"
              disabled={isLoading}
              className="w-full bg-emerald-600 hover:bg-emerald-600/90 text-white py-3 rounded-lg font-body font-semibold transition-all hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 p-4 bg-muted rounded-lg">
            <p className="font-body text-xs text-muted-foreground text-center">
              Default: admin / admin123
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
